import React from 'react';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { Institution } from '../../../../../../global/models/institution-model';

interface Props {
    institution: Institution;
    sectionTitle: string;
    clientNumberLabel: string;
}

function AdoptingInstitutionView(props: Props) {

    const { institution, sectionTitle, clientNumberLabel } = props;


    function AddressView() {

        if (!institution?.physical_address_1 && !institution?.physical_city && !institution?.physical_state) {
            return null;
        }

        return <p>{institution?.physical_address_1}{institution?.physical_address_2}{institution?.physical_address_3}, {institution?.physical_city}, {institution?.physical_state} {institution?.physical_postal_code}</p>;
    }

    return (
        <ContentSpacer>
            <ContentSpacer>
                <h4>{sectionTitle || 'Adopting Institution'}</h4>
            </ContentSpacer>
            <h5>{institution?.organization_name}</h5>
            <p>{clientNumberLabel || 'Client ID'}: {institution?.org_client_nbr}</p>
            {AddressView()}
        </ContentSpacer>
    );

}

export default AdoptingInstitutionView;